import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ExpandIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M3 5L3 19C3 20.103 3.897 21 5 21L19 21C20.103 21 21 20.103 21 19L21 5C21 3.897 20.103 3 19 3L5 3C3.897 3 3 3.897 3 5ZM14.707 12.707L10.707 16.707C10.317 17.097 9.683 17.097 9.293 16.707C8.903 16.317 8.903 15.683 9.293 15.293L12.586 12L9.293 8.707C8.903 8.317 8.903 7.683 9.293 7.293C9.683 6.903 10.317 6.903 10.707 7.293L14.707 11.293C15.098 11.683 15.098 12.317 14.707 12.707Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ExpandIcon.propTypes = {
  sx: PropTypes.object,
};

export default ExpandIcon;
